/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormAuditAssignResponseDto } from '../../models/form-audit-assign-response-dto';

export interface BulkAssignFormAuditor$Params {
  programId: string;
  userId: string;
  body: Array<string>;
}

export function bulkAssignFormAuditor(
  http: HttpClient,
  rootUrl: string,
  params: BulkAssignFormAuditor$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<FormAuditAssignResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, bulkAssignFormAuditor.PATH, 'put');
  if (params) {
    rb.path('programId', params.programId, {});
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FormAuditAssignResponseDto>>;
    })
  );
}

bulkAssignFormAuditor.PATH = '/auditing/bulk/forms/assignment/{programId}/{userId}';
